const MAX_VISIBLE_PATH_SEGMENTS = 6;
const LEADING_SEGMENTS_TO_SHOW = 2;
const TRAILING_SEGMENTS_TO_SHOW = 2;
const MAX_SEGMENT_DISPLAY_LENGTH = 30;

const truncateLongSegment = (segment: string): string => {
  if (segment.length <= MAX_SEGMENT_DISPLAY_LENGTH) {
    return segment;
  }
  return `${segment.substring(0, MAX_SEGMENT_DISPLAY_LENGTH)}...`;
};

export const truncatePathWithSegments = (pathSegments: string[]): string => {
  if (pathSegments.length <= MAX_VISIBLE_PATH_SEGMENTS) {
    return pathSegments.join(" / ");
  }

  const leadingSegments = pathSegments
    .slice(0, LEADING_SEGMENTS_TO_SHOW)
    .map(truncateLongSegment);
  const trailingSegments = pathSegments
    .slice(-TRAILING_SEGMENTS_TO_SHOW)
    .map(truncateLongSegment);

  return `${leadingSegments.join(" / ")} / ... / ${trailingSegments.join(" / ")}`;
};
